import * as React from 'react';
import { CreateBase, Form, Toolbar, useGetIdentity } from 'react-admin';
import { Card, CardContent, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { ContactInputs } from './ContactInputs';
import { Contact } from '../types';

export const ContactCreate = () => {
    const { identity } = useGetIdentity();
    const location = useLocation();
    const redirectTo = (location.state as { redirectTo?: string } | null)
        ?.redirectTo;
    return (
        <CreateBase
            redirect={redirectTo ? () => redirectTo : 'show'}
            transform={(data: Contact) => ({
                ...data,
                first_seen: new Date().toISOString(),
                data_hora: new Date().toISOString(),
                ids_tags: [],
            })}
        >
            <Box mt={2} display="flex">
                <Box flex="1">
                    <Form defaultValues={{ sales_id: identity?.id }}>
                        <Card>
                            <CardContent>
                                <ContactInputs />
                            </CardContent>
                            <Toolbar />
                        </Card>
                    </Form>
                </Box>
            </Box>
        </CreateBase>
    );
};
